<div class="app-shell">
  <app-header></app-header>
  <main class="app-shell__main">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
